// src/components/molecules/table/table-row/TableRow.tsx

import { type TableRowProps } from '.';

const TableRow = ({ children, ...props }: TableRowProps) => {
  return <tr {...props}>{children}</tr>;
};

export default TableRow;
